import { render, staticRenderFns } from "./SmartVenue.vue?vue&type=template&id=2d891213&scoped=true&"
import script from "./SmartVenue.vue?vue&type=script&lang=js&"
export * from "./SmartVenue.vue?vue&type=script&lang=js&"
import style0 from "./SmartVenue.vue?vue&type=style&index=0&id=2d891213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d891213",
  null
  
)

export default component.exports